export default "https://cdn-static.gokick.com/assets/f782299a76cdb7f85e2c64a970a00c34ce21ab93/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";